import { MakeCall } from './createMakeCall';

export default (makeCall: MakeCall) =>
  ({ userId, avatar }: { userId: 'me' | number; avatar: string }) =>
    makeCall<undefined>('PUT', `/api/v2/user/${userId}/avatar`, {
      data: { avatar },
      headers: {
        'Content-Type': 'multipart/form-data; boundary=%s',
      },
    });
